import React, { useEffect, useRef } from "react";
import appConfig from "../../config/index";

const TurnstileWidget = ({ saveTurnstileToken, action, error = "" }) => {
  const widgetRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    const renderWidget = () => {
      if (widgetRef.current && window.turnstile) {
        widgetIdRef.current = window.turnstile.render(widgetRef.current, {
          sitekey: appConfig.turnstile_site_key,
          action: action,
          callback: (token) => {
            saveTurnstileToken(token);
          },
          "error-callback": () => {
            console.error("Turnstile widget encountered an error.");
          },
          size: "flexible",
          theme: "light",
        });
      }
    };

    if (window.turnstile) {
      renderWidget();
    } else {
      const interval = setInterval(() => {
        if (window.turnstile) {
          clearInterval(interval);
          renderWidget();
        }
      }, 100);
      setTimeout(() => clearInterval(interval), 10000); // stop retrying after 10s
    }

    return () => {
      if (window.turnstile && widgetIdRef.current != null) {
        window.turnstile.remove(widgetIdRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (
      error == "Your password was updated." &&
      window.turnstile &&
      widgetIdRef.current != null
    ) {
      window.turnstile.reset(widgetIdRef.current);
    }
  }, [error]);

  return <div ref={widgetRef} />;
};

export default TurnstileWidget;
